import React, { useEffect } from "react";
import hotelForestLocation from "../../../../assets/img/hotel_forest_location.png";
import railwayPng from "../../../../assets/img/railway.png";
import gypsyCenter from "../../../../assets/img/gypsycanter.png";
import nightMode from "../../../../assets/img/night-mode_9554519.jpg";
import airport from "../../../../assets/img/airport.png";
import pawPrint from "../../../../assets/img/pawprint_3175935.png";
import rupee from "../../../../assets/img/rupee_3104891.png";
import parkLock from "../../../../assets/img/park_lock.png";
import * as bootstrap from "bootstrap";
import { Accordion, Col, Row } from "react-bootstrap";

function OverViewTab() {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="tab-content">
          <div className="p-3">
            <Row>
              <Col lg={4} sm={4} md={4} xl={3}>
                <div className="slider_safariimg owl-carousel owl-theme position-relative single-image">
                  <img
                    src="https://www.walkintothewild.in/storage/safaripark/10/logo1732599982.jpg"
                    alt=""
                    className="w-100 mb-xl-0 mb-3"
                  />
                </div>
              </Col>
              <Col xl={9} lg={8} md={8} sm={8} className="position-relative">
                <div className="seelctes_text pb-4 ">
                  <p></p>
                  <p>
                    Satpura National Park, located in the heart of Madhya
                    Pradesh, India, is a hidden gem of biodiversity and
                    wilderness. Spread across an area of 524 square kilometers,
                    it offers a pristine habitat for a diverse range of flora
                    and fauna. Satpura's rugged terrain is characterized by deep
                    gorges, dense forests, and meandering rivers, creating a
                    picturesque landscape that captivates visitors. Home to
                    elusive big cats like leopards and tigers, as well as sloth
                    bears, Indian gaur, and a plethora of bird species, it
                    promises unforgettable wildlife encounters. With its
                    tranquil surroundings and off-the-beaten-path charm, Satpura
                    National Park beckons nature enthusiasts and adventurers
                    seeking an immersive wilderness experience.
                  </p>
                  <p></p>
                </div>
                <Row className="pt-3 desktop_postion border_top2">
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={hotelForestLocation}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Location"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Madhya Pradesh, Central India </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={gypsyCenter}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Safari Mode"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Gypsy / Jeep, Other (Elephant, Boat){" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3">
                      <div className="iconImg">
                        <img
                          src={railwayPng}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Nearest Railway Station"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Pipariya, Itarsi Junction</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={nightMode}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Safari Seasion"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Morning, Evening, Night</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={airport}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Nearest Airport"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Raja Bhoj Airport, Jabalpur Airport, Dr. Babasaheb
                          Ambedkar International Airport
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={pawPrint}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Animals"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Tigers, Leopards, Indian Bison (Gaur), Wild dog
                          (Dholes), Sloth bear, Black buck{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={rupee}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Cost"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          7,000 - 9,000 Average Safari Price (Fully Gypsy) *{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src={parkLock}
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Closed Month"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          July, August, September (buffer open during monsoon){" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  {/* <Col md={6} className="d-lg-none mobile">
                    <div className="btn_wrap pt-md-0 ">
                      <Link
                        to="https://forest.mponline.gov.in/"
                        target="_blank"
                        className="intested_btn"
                      >
                        OFFICIAL WEBSITE{" "}
                      </Link>
                    </div>
                  </Col> */}
                </Row>
              </Col>
              <Col xs={12}>
                <Row className="pt-3 desktop_hideDiv border_top2">
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/hotel_forest_location.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Location"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Madhya Pradesh, Central India </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/gypsycanter.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Safari Mode"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Gypsy / Jeep, Other (Elephant, Boat)
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/railway.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Nearest Railway Station"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Pipariya, Itarsi Junction</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/night-mode_9554519.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Safari Seasion"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">Morning, Evening, Night</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/airport.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Nearest Airport"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Raja Bhoj Airport, Jabalpur Airport, Dr. Babasaheb
                          Ambedkar International Airport
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/pawprint_3175935.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Animals"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          Tigers, Leopards, Indian Bison (Gaur), Wild dog
                          (Dholes), Sloth bear, Black buck{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/Share-Safari/rupee_3104891.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Cost"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          7,000 - 9,000 Average Safari Price (Fully Gypsy) *{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={6} className="mb-3">
                    <div className="safridetails_form d-flex gap-3 ">
                      <div className="iconImg">
                        <img
                          src="/assets/dd598883/img/park_lock.png"
                          alt=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Closed Month"
                        />
                      </div>
                      <div className="text-form">
                        <p className="mb-0">
                          July, August, September (buffer open during monsoon){" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                  {/* <Col md={6} className="d-lg-none mobile">
                    <div className="btn_wrap pt-md-0 ">
                      <Link
                        to="https://forest.mponline.gov.in/"
                        target="_blank"
                        className="intested_btn"
                      >
                        OFFICIAL WEBSITE{" "}
                      </Link>
                    </div>
                  </Col> */}
                </Row>
              </Col>
            </Row>
            <Row className="pt-2">
              <Col xl={6} lg={6} className="mb-3 mb-xl-0">
                <Row className="gx-2 ">
                  <Col sm={3} className="mb-sm-0 mb-3 ">
                    <div className="coreZone h-100">
                      <h3>CORE ZONE</h3>
                    </div>
                  </Col>
                  <Col sm={9} className="mb-sm-0 mb-3">
                    <div className="tabledesigncore">
                      <table className="table w-100 mb-0">
                        <thead>
                          <tr>
                            <th>Zone Name</th>
                            <th>Entry Gate</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="zone_active">
                            <td>Churna</td>
                            <td>Bheemkund Gate</td>
                          </tr>
                          <tr className="zone_active">
                            <td>Madhai</td>
                            <td>Madhai</td>
                          </tr>
                          <tr className="zone_active">
                            <td>Mallupura</td>
                            <td>Bheemkund Barrier Gate </td>
                          </tr>
                          <tr className="zone_active">
                            <td>Panaarpani (Pachmarhi)</td>
                            <td>Panaarpani Gate</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xl={6} lg={6}>
                <Row className="gx-2 ">
                  <Col sm={3} className="mb-sm-0 mb-3">
                    <div className="bufferzone h-100">
                      <h3>BUFFER ZONE</h3>
                    </div>
                  </Col>
                  <Col sm={9} className="mb-sm-0 mb-3">
                    <div className="tabledesignbuffer">
                      <table className="table w-100 mb-0">
                        <thead>
                          <tr>
                            <th>Zone Name</th>
                            <th>Entry Gate</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="">
                            <td>Burgodi (Pipariya)</td>
                            <td> Pipariya Gate </td>
                          </tr>
                          <tr className="">
                            <td>Jamani Dev</td>
                            <td>Sehra Gate </td>
                          </tr>
                          <tr className="">
                            <td>Parsapani </td>
                            <td>Pathai Gate </td>
                          </tr>
                          <tr className="">
                            <td>Tamia Delakhari </td>
                            <td>Seethadongri Gate </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="pt-3">
              <Col xl={7} lg={6} md={5}>
                <div className="legends_bx text-fo">
                  <p className="mb-md-0 mb-2">
                    <sup>
                      <i
                        className="fa fa-asterisk"
                        style={{ fontSize: "10px" }}
                      ></i>
                    </sup>{" "}
                    Safari Price depends on operators and services and may
                    exceed the average price shown
                  </p>
                </div>
              </Col>
              <Col xl={5} lg={6} md={7} >
                <div className="legends_wrap d-flex justify-content-md-end gap-md-4 gap-2 ">
                  <div className="legends_bx d-flex align-items-center gap-2">
                    <div className="legends closedbg"></div>
                    <p>Currently Closed</p>
                  </div>
                  <div className="legends_bx d-flex align-items-center gap-2">
                    <div className="legends Core-Open"></div>
                    <p>Core Zone Open</p>
                  </div>
                  <div className="legends_bx d-flex align-items-center gap-2">
                    <div className="legends BufferZoneOpen"></div>
                    <p>Buffer Zone Open</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default OverViewTab;
